import { Controller } from 'stimulus'
import Rails from '@rails/ujs'

export default class extends Controller {
  static targets = ['queryString', 'intlScope']

  // Lists a new page of items when show more button is clicked
  showMore(event) {
    event.preventDefault()
    const dataset = event.target.dataset
    // TODO: Calculate offset in the backend API call instead
    if (parseInt(dataset.offset) >= 0) {
      dataset.offset = parseInt(dataset.offset) + parseInt(dataset.pageSize)
    }
    this.updateShowMoreVisibility(event.target)
    Rails.ajax({
      type: 'get',
      url: '/collection_select/linked_items/show_more',
      data: $.param({
        query_string: this.queryStringTarget.value,
        intl_scope: this.intlScopeTarget.value,
        type: dataset.type,
        stakeholder_type: dataset.stakeholderType,
        offset: dataset.offset,
        name: dataset.name
      }),
      success: (data) => {
        const doc = new DOMParser().parseFromString(data.html, 'text/html')
        const list = event.target.previousElementSibling
        list.innerHTML += doc.body.innerHTML
        if (data.offset) {
          dataset.offset = data.offset
        }
      }
    })
  }

  // Hides the show more button if there are no more items
  updateShowMoreVisibility(target) {
    const dataset = target.dataset
    if (dataset.total == null || parseInt(dataset.offset) + parseInt(dataset.pageSize) >= parseInt(dataset.total)) {
      target.classList.add('menu-show-more-hidden')
    }
  }
}
